import { Box, Typography } from "@mui/material";
import NavigationRedirectBox from "../../../../common/components/box/NavigationRedirectBox";
import { RouteEnum } from "../../../../common/models/enums";

const AdminNavigationTab = () => {
  return (
    <Box padding="0" marginBottom="1em" width="100%">
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mb: "1em",
        }}
      >
        <Typography variant="h5">Admin navigation</Typography>
      </Box>

      <NavigationRedirectBox
        title="HV Review"
        route={RouteEnum.HumanValidator}
      />
    </Box>
  );
};

export default AdminNavigationTab;
